<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <graph-tool-bar :showSource="false" @on-selected="onPanelSelect" :dateRangeMenu="false"></graph-tool-bar>
      <br />
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-warning">
          <div class="card-icon">
            <md-icon>list</md-icon>
          </div>
          <h4 class="title">{{$lang.titles.meters_list}}</h4>
        </md-card-header>

        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
            v-if="metersData.length"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">{{$lang.inputs.number_of_rows}}</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >{{ item }}</md-option>
                </md-select>
              </md-field>

              <md-field>
                <label>{{$lang.inputs.search}}</label>
                <md-input
                  type="search"
                  class="mb-2"
                  clearable
                  style="max-width: 200px"
                  placeholder="Search meter"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Actions">
                <DeleteMeter
                  :deviceMAC="selected.device.mac"
                  :ID="item.ID_meter.value"
                  @onFinish="onDeleteFinish"
                />

                <md-button
                  class="md-just-icon md-info md-simple"
                  :title="[(item.count_of_tests.value === 0) ? '': 'Load points of meter']"
                  @click="goToDetails(item.ID_meter.value)"
                  :disabled="item.count_of_tests.value === 0"
                >
                <md-tooltip v-if="item.count_of_tests.value === 0" md-direction="bottom">No stored load points</md-tooltip>
                  <md-icon>analytics</md-icon>
                </md-button>
              </md-table-cell>

              <md-table-cell
                v-for="cell in showInTable"
                :key="cell.key"
                :md-label="cell.name"
                :md-sort-by="cell.short ? cell.key : null"
              >
                <span
                  v-if="cell.key != 'MTIME'"
                  v-show="!item[cell.key].edit"
                  @dblclick="showInput(item[cell.key], cell.key)"
                  style="cursor: pointer;"
                >{{ item[cell.key].value }}</span>

                <span v-else>{{ item[cell.key].value }}</span>

                <md-field
                  v-if="cell.key != 'MTIME'"
                  v-show="item[cell.key].edit"
                  @dblclick.native="item[cell.key].edit = false"
                >
                  <label>Edit</label>
                  <md-input
                    v-on:keyup.enter="submitEdited(item[cell.key], item)"
                    :ref="cell.key"
                    v-model="item[cell.key].value"
                  ></md-input>
                </md-field>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <div v-if="!metersData.length">
            <md-empty-state
              md-icon="filter_none"
              md-label="Any stored meters"
              md-description="No stored meters in database"
            ></md-empty-state>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class>
            <p
              class="card-category"
            >{{$lang.general.showing}} {{ from + 1 }} - {{ to }} {{$lang.general.of}} {{ total }} {{$lang.general.rows}}</p>
          </div>

          <div>
            <router-link :to="{name: 'meter_add'}">
              <md-button class="md-info">
                <span class="md-label">
                  <md-icon class="material-icons">add</md-icon>
                </span>
                ADD Meter
              </md-button>
            </router-link>

            <DownloadMeters :deviceMAC="selected.device.mac" @onFinish="onDownloadFinish" />
            <UploadMeters :deviceMAC="selected.device.mac" />
          </div>

          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import { Pagination } from "@/components";
import snackBar from "@/components/SnackBar";
import graphToolBar from "@/components/GraphToolBar";
import UploadMeters from "./UploadMeters";
import DownloadMeters from "./DownloadMeters";
import DeleteMeter from "./DeleteMeter";

import axios from "axios";
import Swal from "sweetalert2";
import format from "date-fns/format";
import Fuse from "fuse.js";
//Alternative search plugin
//https://medium.appbase.io/building-booksearch-application-using-vue-and-elasticsearch-a39615f4d6b3

import { ShowInTable } from "./DataTypes";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";

export default {
  components: {
    graphToolBar,
    snackBar,
    Pagination,
    UploadMeters,
    DownloadMeters,
    DeleteMeter
  },

  data() {
    return {
      selected: {
        device: {}
      },
      metersData: [],
      showInTable: ShowInTable,
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      currentSort: "MTIME",
      currentSortOrder: "desc",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100]
      }
    };
  },

  computed: {
    deviceList() {
      return this.$store.getters.getDeviceList;
    },

    queriedData() {
      let result = this.metersData;
        if (this.searchedData.length > 0 || this.searchQuery.length > 0) {
          result = this.searchedData;
        }
      return result.slice(this.from, this.to);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.metersData.length;
    }
  },

  watch: {
    searchQuery(value) {
      let result = this.metersData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  },

  methods: {
    goToDetails(value) {
      this.$router.push({ path: `/applied-precision/meter/tests/${value}` });
    },

    customSort(value) {
      let propertyName = "value";
      if (this.currentSort === "MTIME") {
        propertyName = "ts";
      }
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return String(b[sortBy][propertyName]).localeCompare(
            String(a[sortBy][propertyName])
          );
        }
        return String(a[sortBy][propertyName]).localeCompare(
          String(b[sortBy][propertyName])
        );
      });
    },

    onPanelSelect(data) {
      if (!this.selected.device.mac) {
        this.getMeters(data.device.mac);
      } else if (this.selected.device.mac != data.device.mac) {
        this.getMeters(data.device.mac);
      }
      this.selected = data;
    },

    formatDateTime(ts) {
      return format(ts * 1000, "DD.MM.YYYY HH:mm:ss");
    },

    onDownloadFinish() {
      this.getMeters(this.selected.device.mac);
    },

    onDeleteFinish() {
      this.getMeters(this.selected.device.mac);
    },

    submitEdited(item, object) {
      item.edit = false;

      let meter = {};
      Object.keys(object).forEach(key => {
        if (key == "MTIME") {
          meter[key] = object[key].ts;
        } else {
          if (object[key].value == "-") {
            meter[key] = "";
          } else {
            meter[key] = object[key].value;
          }
        }
      });

      delete meter.ID_meter;

      axios({
        method: "PUT",
        url: this.$ENDPOINTS.API_W + "/applied-precision/meters",
        data: {
          device_token: getSelectedDeviceToken(this.selected.device.mac),
          ID_meter: object.ID_meter.value,
          meter: meter
        },
        withCredentials: true
      })
        .then(() => {
          this.$refs.snackbar.notify("Database successfully updated");
        })
        .catch(error => {
          this.$refs.snackbar.notify("Failed database udate");
          console.log(error);
        });
    },

    showInput(item, key) {
      item.edit = true;
      this.$nextTick(() => {
        this.$refs[key][0].$el.focus();
      });
    },

    getMeters(deviceMAC) {
      this.$store.commit("setLoading", true);
      this.metersData = [];

      this.$nextTick(() => {
        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_R + "/applied-precision/meters",
          data: {
            device_token: getSelectedDeviceToken(deviceMAC)
          },
          withCredentials: true
        })
          .then(response => {
            for (const element of response.data.data) {
              const objArray = Object.keys(element);
              let newPush = {};

              objArray.forEach(key => {
                newPush[key] = {
                  value: element[key].length != 0 ? element[key] : "-",
                  edit: false
                };
                if (key == "MTIME") {
                  newPush[key].value = this.formatDateTime(element[key]);
                  newPush[key].ts = element[key];
                }
              });

              this.metersData.push(newPush);
            }

            this.metersData = this.customSort(this.metersData);

            this.fuseSearch = new Fuse(this.metersData, {
              threshold: 0.3,
              minMatchCharLength: 2,
              keys: [
                "SNUM.value",
                "TYPE.value",
                "PRODUCER.value",
                "YMAN.value",
                "LOCATION.value",
                "CUSTOMER.value",
                "AREA.value",
                "ADDRESS.value",
                "MTIME.value"
              ]
            });

            this.$store.commit("setLoading", false);
          })
          .catch(error => {
            this.$store.commit("setLoading", false);
            if (error.response) {
              if (error.response.data.code === 610) {
                this.metersData = [];
              }
            }
          });
      });
    }
  }
};
</script>


<style lang="scss" scoped>
.md-toolbar {
  position: inherit;
}
.md-button.md-info:disabled{
  opacity: 0.3;
  pointer-events: visible;
  cursor: not-allowed;
}
</style>
